import React from "react"

export function PoliticaCookies() {
  return (
    <div className="flex flex-col gap-4">
      <p>
        Cookies são arquivos de texto baixados e armazenados automaticamente no dispositivo durante a navegação em um site. Os cookies enviados pelo Elo Feat dos Sonhos visam melhorar o desempenho dos sites e personalizar a experiência do usuário. É possível bloquear esses cookies a qualquer momento, mas isso pode resultar na perda de uma experiência personalizada e na possível limitação de algumas funcionalidades.
        Consulte também a <a href="https://www.elo.com.br/termos-e-regulamentos/cookies-elo" target="_blank" title="Acesse nossa política de cookies da elo" className="underline">Política de Cookies da Elo</a>.
      </p>
    </div>
  )
}
